<script setup lang="ts">
import type { CmsElementZebraCmsExpandableText } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsExpandableText;
}>();

const { headlineText, teaserText, readmoreText } = props.content?.config
const open = ref(false);

const stripHTMLTags = (str) => {
  if(str) {
  return str.replace(/<[^>]*>/g, '');
  }

  return str;
}

let teaser = '';
if(teaserText.value) {
  teaser = stripHTMLTags(teaserText.value).substring(0, stripHTMLTags(teaserText.value).length - 50) + '<span class="opacity-20">'+stripHTMLTags(teaserText.value).substring(stripHTMLTags(teaserText.value).length - 50)+'</span>'
}

</script>
<template>
  <client-only>
    <section class="section-product mt-3">
      <div class="container">
        <div class="max-w-[570px]">
          <h1 class="category-title mb-0 md:mb-5">{{headlineText.value}}</h1>
          <div class="hidden md:block">
            <div v-if="!open" v-html="teaser"></div>
            <div v-if="open" v-html="teaserText.value"></div>
            <div v-if="open" v-html="readmoreText.value"></div>
          </div>
          <a v-if="teaserText.value" href="javascript:void(0);" @click="open = !open" class="mt-5 hidden md:inline-block">{{$t('button.read.more')}} <i class="fa-solid fa-angle-right"></i></a>
        </div>
      </div>
    </section>
  </client-only>
</template>
